export default __webpack_public_path__ + "static/media/vip-deposit-marathon-challenges.a1d4e0bc.webp";